import { cn } from "@/lib/utils";
import creditChart from "../../assets/section-four/credit-chart.svg?inline";
import paymentCheck from "../../assets/section-four/payment-check.svg?inline";
import portrait from "../../assets/section-four/portrait.jpg?inline";

type TCtaPortraitProps = {
	className?: string;
};

/**
 * Portrait of the S4 CTA card — Figma 3137:214.
 * Mobile stacked layout uses 16:12; `lg+` side-by-side grid fills the full card row height at 360px wide.
 * Overlays are HTML so type stays sharp at 2x.
 */
export function CtaPortrait({ className }: TCtaPortraitProps) {
	return (
		<div
			className={cn(
				"relative aspect-[16/12] w-full shrink-0 overflow-hidden bg-greige-400 lg:aspect-auto lg:h-full lg:w-[360px] lg:self-stretch",
				className,
			)}
		>
			<img
				alt=""
				className="pointer-events-none absolute inset-0 size-full object-cover object-[center_38%] select-none lg:object-[center_45%]"
				height={800}
				src={portrait}
				width={720}
			/>

			<div aria-hidden="true" className="absolute inset-0 flex items-center justify-center lg:block">
				<div className="relative h-[100px] w-[302px] shrink-0 lg:h-full lg:w-full">
					<div className="absolute top-0 left-0 flex h-[65px] w-[212px] flex-col justify-center bg-white px-3.5 lg:top-[163px] lg:left-8">
						<p className="m-0 flex items-center gap-1.5 whitespace-nowrap text-[10px] font-normal leading-none tracking-[-0.02em] text-teal-500">
							<span className="inline-flex size-[9px] shrink-0 overflow-clip">
								<img alt="" className="size-full" height={9} src={paymentCheck} width={9} />
							</span>
							Payment submitted successfully
						</p>
						<p className="m-0 mt-1 leading-none">
							<span className="text-[22px] font-semibold tracking-[-0.02em] text-teal-500">£52,495</span>
							<span className="text-[15px] font-semibold tracking-[-0.01em] text-grey-1000">.00</span>
						</p>
					</div>

					<div className="absolute top-[43px] left-[130px] z-10 flex h-[51px] w-[172px] items-center gap-2 bg-[rgba(3,16,18,0.54)] px-3 backdrop-blur-[10px] backdrop-saturate-125 lg:top-[206px] lg:left-[162px]">
						<span className="inline-flex size-[27px] shrink-0 overflow-clip">
							<img alt="" className="size-full" height={27} src={creditChart} width={27} />
						</span>
						<div className="shrink-0">
							<p className="m-0 whitespace-nowrap text-[10px] font-normal leading-none tracking-[-0.02em] text-white [text-shadow:0_1px_5px_rgba(22,31,26,0.09)]">
								Triffin Credit remaining
							</p>
							<p className="m-0 mt-1 leading-none text-white [text-shadow:0_1px_7px_rgba(0,0,0,0.15)]">
								<span className="text-[13px] font-semibold tracking-[-0.02em]">£264,255</span>
								<span className="text-[9px] font-semibold">.00</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
